import { bus } from "@/main";
import { getCurrentExhibitionsList } from "../../../data/models/exhibition.model";
import { getExhibitionsList, getExhibitionEntry } from "../../../data/models/exhibition.model";
import { getProductsList } from "../../../data/models/product.model";
import { getNewsList } from "../../../data/models/article.model";
import { getSuggestionsList } from "../../../data/models/suggestion.model";
import i18n from "vue-i18n"

export default {
	name: "HomePage",
	data() {
		return {
			current: [],
			publications: [],
			news: [],
			exhibitions: [],
			suggestions: [],
			isReadySuggestions: false,
			isReadyCurrent: false,
			isReadyPublications: false,
			isReadyExhibitions: false,
			isReadyNews: false,
			openIndex: -1,
			language: this.$route.params.lang,
			url: window.location.href,
		}
	},
	props: {},
	created() {
		this.getContent();
		bus.$emit("hideTitle", false);
	},
	watch: {
		"$route": function() {
			this.current = null;
			this.getContent();
			this.language = this.$route.params.lang
			body.classList.remove("no--scroll");
			this.openIndex = -1;
		},
		openIndex: function(val) {
			let body = document.querySelector("body");
			if (val >= 0)
				body.classList.add("no--scroll")
			else
				body.classList.remove("no--scroll")
		}
	},
	computed: {},
	methods: {
		getContent() {
			let currentExhibition = new Promise((resolve, reject) => {
				getCurrentExhibitionsList().then(
					content => {
						this.current = content.content;
						resolve(true);
					}
				);
			})
			let suggestionsList = new Promise((resolve, reject) => {
				getSuggestionsList().then( content => {
					this.suggestions = content.content;
					this.isReadySuggestions = true;
					resolve(true);
				});
			})
			let productsList = new Promise((resolve, reject) => {
				getProductsList(1).then(
					content => {
						this.publications = content.content;
						this.isReadyPublications = true;
						resolve(true);
					}
				)
			})
			let newsList = new Promise((resolve, reject) => {
				getNewsList(1, 1, 3).then(
					content => {
						this.news = content.content;
						this.isReadyNews = true;
						resolve(true);
					}
				);
			})
			let exhibitionsList = new Promise((resolve, reject) => {
				getExhibitionsList(1, 1, 100).then(
					content => {
						this.exhibitions = content.content;
						this.isReadyExhibitions = true;
						resolve(true);
					}
				);
			})
			Promise.all([currentExhibition, exhibitionsList, productsList, newsList, suggestionsList]).then(() => {
				bus.$emit("evalColors", true);
				// Set Current Exhibition
				for ( const exhibition of this.exhibitions ) {
					for (const id of this.current) {
						if (id === exhibition.id) {
							let index = this.current.indexOf(id)
							this.current.splice( index, 1, exhibition )
						}
					}
				}
				this.isReadyCurrent = true;
				bus.$emit("PAGE_IS_READY", true);
			})
		},
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/home/home.page.js